import VueRouter from 'vue-router';
Vue.use(VueRouter);

Vue.directive('tooltip', function(el, binding){
    $(el).tooltip({
        title: binding.value,
        placement: binding.arg,
        trigger: 'hover'
    })
})

if(typeof window.sharedData.endpoint_searchresults != "undefined") {

    const router = new VueRouter({
        mode: 'history',
        base: __dirname,
        routes: []
    });


    const vueAuthors = new Vue({
        router,
        el: '#vue_article_search',
        data: {
            searchterm: '',
            year_selected: '',
            category_selected: '',
            issue_selected: '',
            only_titles: false,
            strict_search: false,
            and_search: false,
            categories: window.sharedData.categories,
            issues: window.sharedData.issues,
            loading: false,
            search_submitted: false,
            language: window.sharedData.language,

            searchresults: [],

            endpoint_results: window.sharedData.endpoint_searchresults,
        },
        created: function() {

            if (typeof this.$route.query.search !== 'undefined') {
                this.searchterm = this.$route.query.search;
            }

            if (typeof window.sharedData.results !== 'undefined') {
                this.searchresults = window.sharedData.results;
            }
        },
        methods: {
            search() {

                if (this.searchterm === ''
                    && this.year_selected === ''
                    && this.issue_selected === ''
                    && this.category_selected === ''
                ) {
                    this.searchresults = [];
                    this.loading = false;
                    this.search_submitted = false;
                    return;
                }

                this.loading = true;

                axios.get(this.endpoint_results, { params: {
                        year: this.year_selected,
                        issue_number: this.issue_selected,
                        category: this.category_selected,
                        search: this.searchterm,
                        only_titles: this.only_titles,
                        strict_search: this.strict_search,
                        and_search: this.and_search,
                        language: this.language,
                    }}).then(response => {
                    this.searchresults = response.data;
                    this.loading = false;
                    this.search_submitted = true;
                });

            },
        },
        watch: {
            year_selected: function () {
                this.issue_selected = '';
            }
        },
        computed: {

            results_sorted: function() {
                return _.sortBy(this.searchresults, 'sort_issue').reverse().slice(0,100);
            },

            years: function () {
                return _.map(this.issues, 'year');
            },

            issues_available: function () {
                if (this.year_selected === '') {
                    return [];
                }

                return  this.issues[this.year_selected]['issues'];

            }
        }
    });
}



// WEBPACK FOOTER //
// ./resources/js/frontend.search.js